import React from "react";
import { RCCHookToast, RCCLov } from "react-common-components";
import ILovComponent from "react-common-components/dist/components/Lov/interface";
import { useAuth } from "src/context/Auth/context";
import { PermissionEnum } from "src/context/Auth/interface";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";

const LovProcess: React.FC<Omit<ILovComponent, 
	"valueProperty" | 
	"labelProperty" | 
	"routeAPI" | 
	"routeAPICreate" | 
	"formatCreateLabel" | 
	"callbackErrorOnCreate">
 > = ({
 	name,
 	control,
 	label,
 	isCreatable,
 	...rest
 }) => {
 	const { translate } = useTranslation();
 	const { addToast } = RCCHookToast();
 	const { checkIfHasSpecificPermission } = useAuth();	
 	const isCreatableInternal = isCreatable && checkIfHasSpecificPermission("process", PermissionEnum.CREATE_UPDATE);

 	return(
 		<RCCLov 
			
 			label={label}
 			name={name}
 			control={control}
 			routeAPI="Process/Lov"
 			valueProperty="Taa005Id"
 			labelProperty="Taa005Descricao"
 			elementsPerPage={20}
 			isCreatable = {isCreatableInternal}
 			routeAPICreate="Process/InsertFromLov"
 			formatCreateLabel={(userInput: string) => `+ ${translate("Criar novo processp")}: ${userInput}`}
 			callbackErrorOnCreate={(err) => standardErrorMessages(err, translate("Erro ao adicionar Processo"), addToast)}

 			placeholder={isCreatableInternal ?translate("Digite para filtrar ou criar as opções"):translate("Digite para filtrar as opções")}
 			{...rest}
 		/>
 	);
 };

export default LovProcess;
